import React from "react";
import PropTypes from "prop-types";
import { Box, Chip, Collapse, IconButton, Paper, Typography } from '@mui/material';
import Tooltip from '../Shared/CopyableTooltip';
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import TicketChat from "./TicketChat";
import TicketAssign from "./TicketAssign";
import {
  formatTicketDate,
  getTicketStateColor,
  getTicketStateLabel,
  TICKET_STATE,
} from "../../services/adminTicketUtils";

const TicketsCard = ({
  ticket,
  expanded,
  onToggle,
  loginId,
  isAdmin,
  onTicketUpdated,
  onMessagesRead,
}) => {
  const showUnread = ticket.unreadCount > 0
    && (ticket.state === TICKET_STATE.IN_LAVORAZIONE || ticket.state === TICKET_STATE.CHIUSO);

  return (
    <Paper sx={{ mb: 2, borderRadius: "12px", overflow: "hidden", backgroundColor: "#fff" }}>
      <Box
        onClick={onToggle}
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "flex-start", md: "center" },
          justifyContent: "space-between",
          gap: 2,
          px: 3,
          py: 2,
          cursor: "pointer",
        }}
      >
        <Box flex={1} minWidth={0} width={{ xs: "100%", md: "auto" }}>
          {ticket.vendorBusinessName ? (
            <Typography sx={{ fontFamily: "Rubik", fontWeight: "bold", color: "#0b3d87", wordBreak: "break-word" }}>
              {ticket.vendorBusinessName}
            </Typography>
          ) : null}
          <Typography sx={{ fontFamily: "Rubik", fontSize: 13, fontWeight: "bold", color: "#808080", wordBreak: "break-word", mt: 0.25 }}>
            {ticket.subject}
          </Typography>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          flexShrink={0}
          flexWrap="wrap"
          width={{ xs: "100%", md: "auto" }}
          justifyContent={{ xs: "flex-start", md: "flex-end" }}
        >
          {showUnread ? (
            <Chip
              size="small"
              label={ticket.unreadCount}
              sx={{ fontFamily: "Rubik", backgroundColor: "#e00036", color: "#fff", fontWeight: 700 }}
            />
          ) : null}

          <Chip
            size="small"
            label={getTicketStateLabel(ticket.state)}
            sx={{ fontFamily: "Rubik", fontWeight: 700, backgroundColor: getTicketStateColor(ticket.state), color: "#fff" }}
          />
          <Tooltip title="Data ultimo aggiornamento">
            <Chip
              size="small"
              variant="outlined"
              label={formatTicketDate(ticket.updatedAt ?? ticket.createdAt)}
              sx={{ fontFamily: "Rubik", borderColor: "#0b3d87", color: "#0b3d87" }}
            />
          </Tooltip>
          <IconButton size="small">{expanded ? <ExpandLess /> : <ExpandMore />}</IconButton>
        </Box>
      </Box>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Box sx={{ px: 3, pb: 3 }}>
          <TicketChat
            ticket={ticket}
            loginId={loginId}
            isAdmin={isAdmin}
            onTicketUpdated={onTicketUpdated}
            onMessagesRead={onMessagesRead}
          />
          <TicketAssign
            ticket={ticket}
            loginId={loginId}
            onAssigned={onTicketUpdated}
          />
        </Box>
      </Collapse>
    </Paper>
  );
};

TicketsCard.propTypes = {
  ticket: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  loginId: PropTypes.number,
  isAdmin: PropTypes.bool,
  onTicketUpdated: PropTypes.func,
  onMessagesRead: PropTypes.func,
};

TicketsCard.defaultProps = {
  loginId: null,
  isAdmin: false,
  onTicketUpdated: null,
  onMessagesRead: null,
};

export default TicketsCard;
 